<div class="mobile-confirmation__drawer">
    <div class="mobile-confirmation__content">
        @if (mobileNumberConfirmationConfig$ | async; as config) {
            <div class="mobile-confirmation__header">
                <span class="mobile-confirmation__title">{{ config.dialogHeading }}</span>
            </div>
            <div class="mobile-confirmation__body">
                <div class="mobile-confirmation__body-mobile-number-content">
                    <div class="txt-sm-v2 mobile-confirmation__body-mobile-number-title">{{ config.propertyName }}</div>
                    <div class="mobile-confirmation__body-mobile-number">{{ mobileNumber | msFormatPhoneNumber }}</div>
                </div>
                <div class="mobile-confirmation__body-separator"></div>
                <div class="mobile-confirmation__body-message-content">
                    <div class="txt-lg-v2 mobile-confirmation__body-muti-auth-message">{{ config.multiFactorAuthMessage }}</div>
                    <div class="txt-lg-v2 mobile-confirmation__body-update-number-message">{{ config.updateMobileMessage }}</div>
                </div>
                <div class="mobile-confirmation__button-content">
                    <button ds-button kind="primary" class="mobile-confirmation__body-confirmation-button" (click)="confirmMobileNumber()">
                        {{ config.dialogConfirmButtonText }}
                    </button>
                    <button ds-button kind="tertiary" variant="flat" class="mobile-confirmation__body-update-button" (click)="updateMobileNumber()">
                        {{ config.dialogUpdateButtonText }}
                    </button>
                </div>
            </div>
        }
    </div>
</div>
